import { render, staticRenderFns } from "./DuplicatesReports.vue?vue&type=template&id=cbf4a442&scoped=true"
import script from "./DuplicatesReports.vue?vue&type=script&lang=js"
export * from "./DuplicatesReports.vue?vue&type=script&lang=js"
import style0 from "./DuplicatesReports.vue?vue&type=style&index=0&id=cbf4a442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf4a442",
  null
  
)

export default component.exports